




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DropdownPricingType extends Vue {
  @Prop({}) readonly transactionCreate!: any;

  private optionsPricingType = [
    { name: "แยกภาษี", value: 0 },
    { name: "รวมภาษี", value: 1 },
    { name: "ไม่มี", value: 2 },
  ];
  private selectPricingType: any = "";

  @Watch("transactionCreate.taxStatus", { immediate: true, deep: true })
  taxStatusChanged() {
    // if (
    //       this.selectedMerchant.merchant &&
    //       !this.selectedMerchant.merchant.isVat &&
    //       this.transactionCreate.financeType === FinanceType.InFlow
    //     ) {
    //       this.selectPricingType = { name: this.$t("None"), value: 2 };
    //       this.transactionCreate.taxStatus.disabled = true;
    //     } else {
    //       this.selectPricingType = this.optionsPricingType.find((item) => {
    //         return item.value == this.transactionCreate.taxStatus.value;
    //       });
    //     }

    this.selectPricingType = this.optionsPricingType.find((item) => {
      return item.value == this.transactionCreate.taxStatus.value;
    });
  }

  @Watch("selectPricingType", { deep: true })
  selectPricingTypeChanged() {
    this.DoSelectTaxStatus(this.selectPricingType);
  }

  public DoSelectTaxStatus(item: any) {
    this.transactionCreate.taxStatus.value = item.value;
    this.$emit("change");
  }
}
